import {
  DeletePersonProfilesPayload,
  DeletePersonProfilesResponse,
} from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useDeletePersonProfiles(
  onSuccess?: (data: DeletePersonProfilesResponse) => void,
  onError?: (err: Error) => void
) {
  const url = `/v2/orm/person_profile/delete_profiles`;

  const request = new Request(url, {
    method: 'DELETE',
  });

  return useAuthenticatedMutation<
    DeletePersonProfilesResponse,
    DeletePersonProfilesPayload
  >(request, {
    onSuccessInvalidationKeys: [['person_match_profiles']],
    onSuccess,
    onError,
  });
}

export default useDeletePersonProfiles;
